import React, { useEffect, useState } from 'react'
import {
    ButtonBack,
    ButtonFinish,
    ButtonNext,
    FooterLink,
    FormDiv,
    FullHeaderContainer,
    GridContainer,
    HeaderLinkCreate,
    StepperNav,
    Title,
} from './styles'
import Box from '@mui/material/Box'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import { Typography } from '@mui/material'
import Step1 from '../../components/PaymentCreateStepper/Step1'
import Step2 from '../../components/PaymentCreateStepper/Step2'
import Step3 from '../../components/PaymentCreateStepper/Step3'
import { useForm, SubmitHandler } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import swal from 'sweetalert'
import { useCommision } from '../../hooks/commission'
import { useContacts } from '../../hooks/contacts'
import {
    initialContact,
    InitialContactProtocol,
    Inputs,
    InputsFormStep1,
    InputsFormStep2,
    PaymentData,
} from './interfaces'
import { useSelector } from 'react-redux'
import { StoreState } from '../../store'
import { get } from 'lodash'

import { useBancos } from '../../hooks/bancos'
import api from '../../services/axios'
import dayjs from '../../libs/dayjs'
import { OptInAlert } from '../../components/OptInAlert'
import { DocumentRequiredAlert } from '../../components/DocumentRequiredAlert'

const PagamentoCriar: React.FC = () => {
    const { verificationC, cnpj_cpf, isDocumentValid } = useSelector(
        (state: StoreState) => state.auth.user
    )
    const { bancos, getIspb } = useBancos()
    const navigate = useNavigate()
    const { getPaymentCommission } = useCommision()
    const { saveContact, contacts } = useContacts()
    const [activeStep, setActiveStep] = React.useState(0)
    const [skipped, setSkipped] = React.useState(new Set<number>())
    const [paymentData, setPaymentData] = useState<PaymentData>(
        {} as PaymentData
    )
    const [saveContactAsFavs, setSaveContactAsFavs] = useState(true)
    const [selectedFav, setSelectedFav] =
        useState<InitialContactProtocol>(initialContact)
    const [numeroConta, setNumeroConta] = useState('')
    const [valueBanco, setValueBanco] = useState(['', ''])
    const [isLoading, setIsloading] = useState(false)

    // const [nomePagadorInput, setNomePagadorInput] = useState<NomePagadorInput>(NomePagadorInputInitial)
    const { handleSubmit } = useForm<Inputs>()
    const formStep1 = useForm<InputsFormStep1>()
    const formStep2 = useForm<InputsFormStep2>()
    // const formStep3 = useForm<Inputs>()

    useEffect(() => {
        let dataPadrao = dayjs().add(5, 'd')

        if (dataPadrao.day() === 0) {
            dataPadrao = dataPadrao.add(1, 'd')
        }

        if (dataPadrao.day() === 6) {
            dataPadrao = dataPadrao.add(2, 'day')
        }
        formStep2.setValue('tipoPagamento', 0)
        formStep2.setValue('dataLiquidacao', dataPadrao.format('YYYY-MM-DD'))
        formStep2.setValue('quantParcelas', 1)
        formStep2.setValue('frequenciaPagamento', 1)
    }, [formStep2.setValue])

    useEffect(() => {
        if (selectedFav?.id === undefined) {
            formStep1.reset({
                valor: Number(formStep1.getValues('valor')),
                nomeTitular: initialContact.nomeTitular,
                numeroDocumentoTitular: initialContact.numeroDocumentoTitular,
                agencia: initialContact.agencia,
                compe: initialContact.compe,
                ispb: initialContact.ispb,
                numeroConta: initialContact.numeroConta,
                tipoConta: initialContact.tipoConta,
                email: initialContact.email,
                telefone: initialContact.telefone,
            })
            return
        }
        // deselecionar a opcao salvar
        formStep1.reset({
            valor: Number(formStep1.getValues('valor')),
            nomeTitular: selectedFav?.nomeTitular,
            numeroDocumentoTitular: selectedFav?.numeroDocumentoTitular,
            agencia: selectedFav?.agencia,
            compe: selectedFav?.compe,
            ispb: selectedFav?.ispb,
            tipoConta: selectedFav?.tipoConta,
            numeroConta: selectedFav?.numeroConta,
            email: selectedFav?.email,
            telefone: selectedFav?.telefone,
        })
        setNumeroConta(selectedFav?.numeroConta)
        const compe = formStep1.getValues('compe')
        const banco = bancos[compe]
        setValueBanco([compe, banco])
    }, [selectedFav, formStep1.getValues, formStep1.reset])

    if (!verificationC) {
        return <OptInAlert />
    }

    if (!isDocumentValid) {
        return <DocumentRequiredAlert />
    }

    const submitFormStep1: SubmitHandler<InputsFormStep1> = async (inputs) => {
        // alterar o link data
        const newPaymentData: PaymentData = { ...paymentData }
        newPaymentData.nomeTitular = inputs.nomeTitular
        newPaymentData.numeroDocumentoTitular =
            inputs.numeroDocumentoTitular.replace(/\D/g, '')
        newPaymentData.agencia = inputs.agencia
        newPaymentData.compe = inputs.compe
        newPaymentData.ispb = getIspb(inputs.compe)
        newPaymentData.numeroConta = inputs.numeroConta
        newPaymentData.tipoConta = inputs.tipoConta
        newPaymentData.email = inputs.email
        newPaymentData.telefone = inputs.telefone.replace(/\D/g, '')
        newPaymentData.observacao = inputs.observacao
        newPaymentData.valor = inputs.valor
        setPaymentData(newPaymentData)

        // passar para o proximo step
        setActiveStep(1)
    }

    const submitFormStep2: SubmitHandler<InputsFormStep2> = async (inputs) => {
        const newPaymentData: PaymentData = { ...paymentData }
        newPaymentData.tipoPagamento = inputs.tipoPagamento
        newPaymentData.dataLiquidacao = inputs.dataLiquidacao
        newPaymentData.quantParcelas = inputs.quantParcelas
        newPaymentData.frequenciaPagamento = inputs.frequenciaPagamento
        setPaymentData(newPaymentData)
        setActiveStep(2)
    }

    const submitFormStep3: SubmitHandler<Inputs> = async (inputs) => {
        try {
            setIsloading(true)
            if (saveContactAsFavs) {
                await saveContact({
                    cnpj_cpf,
                    nomeTitular: paymentData.nomeTitular,
                    numeroDocumentoTitular: paymentData.numeroDocumentoTitular,
                    agencia: paymentData.agencia,
                    compe: paymentData.compe,
                    ispb: paymentData.ispb,
                    numeroConta: paymentData.numeroConta,
                    tipoConta: paymentData.tipoConta,
                    email: paymentData.email,
                    telefone: paymentData.telefone,
                    contactId: selectedFav?.id || undefined,
                })
            }
            const { data } = await api.post(`/pagamento/personalizado`, {
                cnpj_cpf: cnpj_cpf,
                valor: Number(paymentData.valor),
                nomeTitular: paymentData.nomeTitular,
                numeroDocumentoTitular: paymentData.numeroDocumentoTitular,
                agencia: paymentData.agencia,
                compe: paymentData.compe,
                ispb: paymentData.ispb,
                numeroConta: paymentData.numeroConta,
                tipoConta: paymentData.tipoConta,
                email: paymentData.email,
                telefone: paymentData.telefone.replace(/\D/g, ''),
                dataLiquidacao: paymentData.dataLiquidacao,
                observacao: paymentData.observacao,
                tipoPagamento: paymentData.tipoPagamento,
                quantParcelas: Number(paymentData.quantParcelas),
                frequenciaPagamento: Number(paymentData.frequenciaPagamento),
            })
            swal({
                title: 'Pagamento concluído com sucesso!',
                text: `Você já faz parte do futuro 🚀`,
                icon: 'success',
            })
            setIsloading(false)
            navigate('/pagamento')
        } catch (error) {
            const messageError = get(error, 'response.data.error', '')
            swal({
                title: 'Erro ao criar pagamento',
                text: `${messageError}`,
                icon: 'error',
            })
            setIsloading(false)
        }
    }

    function renderActiveStep() {
        switch (activeStep) {
            case 0:
                return (
                    <Step1
                        saveContactAsFavs={saveContactAsFavs}
                        setSaveContactAsFavs={setSaveContactAsFavs}
                        submitFormStep1={submitFormStep1}
                        formStep1={formStep1}
                        contacts={contacts}
                        setSelectedFav={setSelectedFav}
                        setValueBanco={setValueBanco}
                        valueBanco={valueBanco}
                        numeroConta={numeroConta}
                        handleChange={handleChange}
                    />
                )
            case 1:
                return (
                    <Step2
                        paymentData={paymentData}
                        submitFormStep2={submitFormStep2}
                        formStep2={formStep2}
                    />
                )
            case 2:
                return (
                    <Step3
                        paymentData={paymentData}
                        getPaymentCommission={getPaymentCommission}
                        setActiveStep={setActiveStep}
                        numeroConta={numeroConta}
                    />
                )
        }
    }

    const steps = ['Informações do recebedor', 'Formas de pagamento', 'Resumo']

    const isStepOptional = (step: number) => {
        return step === 10
    }

    const isStepSkipped = (step: number) => {
        return skipped.has(step)
    }

    const handleNext = () => {
        let newSkipped = skipped
        if (activeStep === steps.length - 1) {
            return
        }
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values())
            newSkipped.delete(activeStep)
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1)
        setSkipped(newSkipped)
    }

    const handleBack = () => {
        if (activeStep === 0) return
        setActiveStep((prevActiveStep) => prevActiveStep - 1)
    }
    function handleChange(
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) {
        if (e.target.name === 'numeroConta') {
            let value = e.target.value
            value = value.replace(/\D/g, '')
            const array = value.split('')
            const ultimoDigito = array.pop()
            const contaSemDigito = array.join('')
            let conta = ultimoDigito
            if (array.length >= 1) {
                conta = `${contaSemDigito}-${ultimoDigito}`
            }
            e.target.value = conta || ''
            setNumeroConta(e.target.value)
        }
    }

    return (
        <GridContainer>
            <FullHeaderContainer>
                <HeaderLinkCreate>
                    <Title>Criar Pagamento</Title>
                </HeaderLinkCreate>

                <StepperNav>
                    {
                        <Box sx={{ width: '75%' }}>
                            <Stepper activeStep={activeStep} alternativeLabel>
                                {steps.map((label, index) => {
                                    const stepProps: { completed?: boolean } =
                                        {}
                                    const labelProps: {
                                        optional?: React.ReactNode
                                    } = {}
                                    if (isStepOptional(index)) {
                                        labelProps.optional = (
                                            <Typography variant="caption">
                                                Optional
                                            </Typography>
                                        )
                                    }
                                    if (isStepSkipped(index)) {
                                        stepProps.completed = false
                                    }
                                    return (
                                        <Step key={label} {...stepProps}>
                                            <StepLabel {...labelProps}>
                                                {label}
                                            </StepLabel>
                                        </Step>
                                    )
                                })}
                            </Stepper>
                        </Box>
                    }
                </StepperNav>
            </FullHeaderContainer>

            <FormDiv
                onSubmit={handleSubmit(submitFormStep3)}
                id="payment-step-3"
            >
                {activeStep === steps.length ? (
                    <React.Fragment>
                        <Typography sx={{ mt: 2, mb: 1 }}>
                            All steps completed - you&apos;re finished
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                pt: 2,
                            }}
                        >
                            <Box sx={{ flex: '1 1 auto' }} />
                        </Box>
                    </React.Fragment>
                ) : (
                    <React.Fragment>{renderActiveStep()}</React.Fragment>
                )}
            </FormDiv>
            <form
                className="sr-only"
                id="payment-step-1"
                onSubmit={formStep1.handleSubmit(submitFormStep1)}
            ></form>
            <form
                className="sr-only"
                id="payment-step-2"
                onSubmit={formStep2.handleSubmit(submitFormStep2)}
            ></form>

            <FooterLink>
                {activeStep === 0 ? (
                    <></>
                ) : (
                    <ButtonBack onClick={handleBack}>Voltar</ButtonBack>
                )}
                {activeStep === 0 && (
                    <ButtonNext type="submit" form="payment-step-1">
                        Avançar
                    </ButtonNext>
                )}
                {activeStep === 1 && (
                    <ButtonNext type="submit" form="payment-step-2">
                        Avançar
                    </ButtonNext>
                )}
                {activeStep === steps.length - 1 && (
                    <ButtonFinish
                        type="submit"
                        form="payment-step-3"
                        disabled={isLoading}
                    >
                        Finalizar
                    </ButtonFinish>
                )}
            </FooterLink>
        </GridContainer>
    )
}

export default PagamentoCriar
